export default __webpack_public_path__ + "static/media/street-view-color.1eb9e52f.svg";